export const selectLoginDomain = () => (state) => state.login;
